export default __webpack_public_path__ + "static/media/pench_nagpur_5.45f22857.jpg";